import React from 'react';
import { LiferayProps } from '../..';
import FormExamens from '../form/FormExamens'; // Asegúrate de importar tu componente
import Details from '../details/DetailsExamens'; // Asegúrate de importar tu componente Details
import './MainView.scss';

const MainView: React.FC<LiferayProps> = ({properties}) => {
  // Verifica si SesionStorage está vacío

  const hasCardData = sessionStorage.getItem('cardData') !== null;

  return (
    <div className="main-view">
      {hasCardData ? (
      <>
        <Details properties={properties}/>
        <FormExamens properties={properties} />
      </>
      ) : (
        <FormExamens properties={properties} />
      )}
    </div>   
  );
};

export default MainView;